import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/choose-challenge-type.png'


const _withScopeId = n => (_pushScopeId("data-v-4b7bf5a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page-campaign-cocacola-season-5"
}
const _hoisted_2 = { class: "d-block d-sm-none mobile-navbar" }
const _hoisted_3 = { class: "mobile-tabs font-Pretendar" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "d-none d-md-block" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "scroll-page" }, null, -1))
const _hoisted_7 = { class: "d-none d-md-block" }
const _hoisted_8 = { class: "chooseChallenge font-Pretendar" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-center cola-color fw-bold" }, " 챌린지 선택하기 ", -1))
const _hoisted_10 = { class: "d-flex w-100 gap-5 mt-5" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "챌린지 선택",
  class: "w-100 mt-3"
}, null, -1))
const _hoisted_12 = { class: "footer-btn-group" }
const _hoisted_13 = { class: "ss6-footer" }

import PageMain from './components/page-main.vue';
import Navbar from './components/navbar.vue';
import CheckPopups, { type CheckExpose } from './components/popups/check.vue';
import QuizPoupups, { type QuizeExpose } from './components/popups/quiz.vue';
import ParticipatePopups, { type ParticipateExpose } from './components/popups/participate.vue';
import CollectPopups, { type CollectExpose } from './components/popups/collect.vue';
import Participate from './components/participate.vue';
import { provide, ref, inject, nextTick, toRef, reactive, computed, Ref, watch, onMounted, onUnmounted } from 'vue';
import 'swiper/css';
import 'swiper/css/pagination';
import _ from 'lodash';
import { IProgram } from '@/types/program';
import PopupError from './components/popups/popup-error.vue';
import { getImages } from './static';
import { useElementBounding, useScroll } from '@vueuse/core';
import { useRoute } from 'vue-router';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import NoticePopup from './components/popups/notice.vue';
import EveryoneChallenge from './components/everyone-challenge.vue';
import HeroSection from './components/hero-section.vue';
import SscolaFooter from './components/sscola-footer.vue';
import CampusChallenge from './components/campus-challenge.vue';
import CautionPage from './components/caution-page.vue';
import PopupChooseChallangeType
  from './components/popups/popup-choose-challange-type.vue';
import EveryoneCollectPage from './components/everyone-collect-page.vue';
import CampusCollectPage from './components/campus-collect-page.vue';
import { Challenge } from '@/templates/campaign-cocacola-season-6/components/model/challenge';

interface IProps {
  program: IProgram;
}interface MenuType {
  name: string;
  key?: 'main' | 'mission' | 'date' | 'method' | 'faq' | 'everyone-challenge' | 'cautionRef' | 'apply';
  pageRef?: Ref<HTMLDivElement | undefined>;
  anchor?: string;
  section?: string;
  onClick?: () => Promise<void> | void;
  disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    program: { default: () => ({} as IProgram) }
  },
  setup(__props: any) {

const props = __props as { program: IProgram }

dayjs.extend(isBetween);

;



provide('program', toRef(props, 'program'));
const programStepData = ref({ isCampusCollectSuccess: false });
provide('programStepData', programStepData);
const navbarIsVisible = ref(true);
const isStartParticipate = ref(false);
const challengeType = ref<'everyone' | 'campus'>('everyone'); // 'everyone' | 'campus'
const isStartCollect = ref(false);

const refreshPageData = inject<Function>('refreshPageData') || _.noop;

const popupVisible = reactive({
  error: false,
  chooseChallenge: false,
});

function hidePopup(key?: keyof typeof popupVisible) {
  if (key) {
    popupVisible[key] = false;
  } else {
    Object.keys(popupVisible).forEach((k) => {
      const popupKey = k as keyof typeof popupVisible;
      if (popupVisible[popupKey]) {
        popupVisible[popupKey] = false;
      }
    });
  }
}

async function showPopup(key: keyof typeof popupVisible) {
  hidePopup();
  await nextTick();
  popupVisible[key] = true;
}

const errMsg = ref('');
const checkPopupsRef = ref<CheckExpose>();
const quizPopupsRef = ref<QuizeExpose>();
const participatePopupsRef = ref<ParticipateExpose>();

async function participate(challengeTypez: 'everyone' | 'campus') {

  const valid = await checkPopupsRef.value?.start();

  if (valid) {
    await refreshPageData();
    await nextTick();

    if (challengeTypez === 'campus') {
      const { show_participate_btn, participate_btn_msg } = props.program || {};
      if (!show_participate_btn) {
        errMsg.value = participate_btn_msg || '';
        showPopup('error');
        return;
      }
    }

    challengeType.value = challengeTypez;
    isStartParticipate.value = true;
    // quizPopupsRef.value?.start();
  }
}

provide('participate', participate);


const collectPopupsRef = ref<CollectExpose>();

async function collect(challengeTypez: 'everyone' | 'campus', programz: any) {
  const valid = await checkPopupsRef.value?.start();
  if (!programz) { await refreshPageData(); }
  programz = programz || props.program;
  if (valid) {

    await nextTick();
    const {
      show_collection_btn,
      collection_count = 0,
      collection_challenge = 0,
      collection_btn_msg
    } = programz || {};
    if (show_collection_btn) {
      // 超过了提交次数
      if (collection_count >= collection_challenge) {
        errMsg.value = `수령하신 제로 웨이스트 박스
  모두 수거 신청 완료되었습니다.`;
        showPopup('error');
        return;
      }
      challengeType.value = challengeTypez;
      isStartCollect.value = true;
      isStartParticipate.value = false;
      // collectPopupsRef.value?.start();
      return;
    }
    errMsg.value = collection_btn_msg || '';
    showPopup('error');
  }
}

provide('collect', collect);

function onQuizeDone() {
  participatePopupsRef.value?.start();
}

function checkWebPSupport(): Promise<boolean> {
  return new Promise((resolve) => {
    const image = new Image();
    image.addEventListener('error', () => resolve(false));
    image.addEventListener('load', () => resolve(image.width > 0 && image.height > 0));
    image.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
  });
}

const supportWebp = ref<boolean | undefined>();
const pageInited = ref(false);
checkWebPSupport()
  .then(support => supportWebp.value = support)
  .catch(() => supportWebp.value = false)
  .finally(() => nextTick(() => {
    pageInited.value = true;
    setTimeout(scrollToAnchorPosition, 300);
  }));

const s5Images = computed(() => getImages(supportWebp.value));
provide('images', s5Images);

let isScrollingProgrammatically = false;

const pageMainRef = ref<HTMLDivElement>();
const everyoneChallengeRef = ref<HTMLDivElement>();
const campusChallengeRef = ref<HTMLDivElement>();
const cautionRef = ref<HTMLDivElement>();

const route = useRoute();

// Current section state (independent of Vue Router)
const currentSection = ref<string>('main');

// Initialize section from URL on mount
onMounted(() => {
  // Use route params to get the section directly
  const childPath = route.params.section as string || '';

  if (childPath && ['modu', 'campus', 'caution'].includes(childPath)) {
    currentSection.value = childPath;
  } else {
    currentSection.value = 'main';
  }

  // Listen for browser back/forward navigation
  window.addEventListener('popstate', handlePopState);
});

onUnmounted(() => {
  window.removeEventListener('popstate', handlePopState);
});

function handlePopState() {
  // Use route params to get the section directly
  const childPath = route.params.section as string || '';

  if (childPath && ['modu', 'campus', 'caution'].includes(childPath)) {
    currentSection.value = childPath;
  } else {
    currentSection.value = 'main';
  }
}

const menus = computed<Array<MenuType>>(() => {
  return [
    {
      name: '원더플 시즌6',
      key: 'main',
      section: 'main',
      pageRef: pageMainRef,
      anchor: '#page-main',
    },
    {
      name: '모두의 챌린지',
      key: 'everyone-challenge',
      section: 'modu',
      pageRef: everyoneChallengeRef,
      anchor: '#page-everyone-challenge',
    },
    {
      name: '캠퍼스 챌린지',
      key: 'date',
      section: 'campus',
      pageRef: campusChallengeRef,
      anchor: '#campusChallenge',
    },
    {
      name: '주의사항',
      key: 'cautionRef',
      section: 'caution',
      pageRef: cautionRef,
      anchor: '#page-caution',
    },
    {
      // 参加
      name: '참여신청하기',
      key: 'apply',
      onClick: popupChooseChallange,
    }
  ].filter(Boolean) as Array<MenuType>;
});

const activeMenuIndex = computed(() => {
  return menus.value.findIndex(menu => menu.section === currentSection.value);
});

const popupChooseChallange = () => {
  if (currentSection.value === 'main') {
    popupVisible.chooseChallenge = true;
  } else if (currentSection.value === 'modu') {
    participate('everyone');
  } else if (currentSection.value === 'campus') {
    participate('campus');
  } else if (currentSection.value === 'caution') {
    popupVisible.chooseChallenge = true;
  }
};

useScroll(window, {
  onScroll() {
    if (isScrollingProgrammatically) {
      return;
    }
  },
  onStop() {
    isScrollingProgrammatically = false;
  },
});

function updateUrl(section: string) {
  const pathSegments = route.path.split('/');

  const baseSegments = pathSegments.slice(0, 3);

  let newPath = `${baseSegments.join('/')}`;

  if (section !== 'main') {
    newPath += `/${section}`;
  }

  if (!newPath.startsWith('/')) {
    newPath = '/' + newPath;
  }

  // Update URL without refreshing page
  window.history.pushState({}, '', newPath);
}

function navToPage(item: typeof menus.value[number]) {
  if (item.onClick) {
    item.onClick();
    return;
  }
  if (item.section) {
    currentSection.value = item.section;
    updateUrl(item.section);
    return;
  }
  if (item.pageRef) {
    isScrollingProgrammatically = true;
    item.pageRef?.value?.scrollIntoView({ block: 'start' });
  }
}

function navToPageByKey(key: MenuType['key']) {
  const item = menus.value.find(item => item.key === key);
  if (item) {
    navToPage(item);
  }
}

provide('navToPageByKey', navToPageByKey);

function onMenuItemClick(item: { name: string; disabled?: boolean; key?: string }) {
  isStartCollect.value = false;
  isStartParticipate.value = false;
  const menuItem = menus.value.find(menu => menu.name === item.name);
  if (menuItem) {
    navToPage(menuItem);
  }
}

const navContainer = ref<HTMLDivElement>();
const { top, height } = useElementBounding(navContainer);
const targetIsVisible = computed(() => {
  const tcHeaderHeight = parseInt(document.body.style.getPropertyValue('--tc-header-height')) || 0;
  return (top.value - tcHeaderHeight) + height.value > 0;
});

watch(
  () => targetIsVisible.value,
  (val) => {
    // navbarIsVisible = val;
    navbarIsVisible.value = val;
  },
  { immediate: true }
);

function scrollToAnchorPosition() {
  const key = route.hash.split('#page-').pop();
  if (key) {
    navToPageByKey(key as any);
  }
}

const showNoticePopup = ref(dayjs().isBefore('2024-07-31T20:00:00.000+09:00', 'millisecond'));

const handleShowError = (message: string) => {
  errMsg.value = message;
  showPopup('error');
};

const addDate = (date: Date, days: number) => {
  date.setDate(date.getDate() + days);
  return date;
};

const rounds = props.program.program_rounds || [];

const sortedRounds = [...rounds].sort((a, b) =>
  new Date(a.participate_started_at).getTime() - new Date(b.participate_started_at).getTime()
);

const campusOrigin = rounds.find(item => item.id === 77);
if (!campusOrigin) {
  console.error('Not find campus Id: 77');
}

const campusChallenge: Challenge =  {
  id: campusOrigin?.id,
  subtitle: '대학생들이 참여하는',
  title: campusOrigin?.title,
  recruitmentFrom: new Date(campusOrigin?.participate_started_at),
  recruitmentTo: new Date(campusOrigin?.participate_ended_at),
  collectionFrom: new Date(campusOrigin?.collection_started_at),
  collectionTo: new Date(campusOrigin?.collection_ended_at),
  participantAnnouncement: addDate(new Date(campusOrigin?.participate_ended_at), 2),
  boxDelivery: addDate(new Date(campusOrigin?.participate_ended_at), 5),
  programId: props.program.id
};

const everyoneChallenges: Challenge[] = rounds.filter(item => item.id !== 77).map(
  round => {
    return {
      id: round.id,
      subtitle: '누구나 참여하는 모두의 챌린지',
      title: round.title,
      recruitmentFrom: new Date(round.participate_started_at),
      recruitmentTo: new Date(round.participate_ended_at),
      collectionFrom: new Date(round.collection_started_at),
      collectionTo: new Date(round.collection_ended_at),
      participantAnnouncement: round.id == 76 ? (new Date(`2025-08-15T10:00:00.000+09:00`)) : (new Date(`2025-07-15T10:00:00.000+09:00`)),
      boxDelivery: round.id == 76 ? (new Date(`2025-08-15T10:00:00.000+09:00`)) : (new Date(`2025-07-15T10:00:00.000+09:00`))
    };
  }
);
everyoneChallenges[0].programId = 232;
everyoneChallenges[1].programId = 233;

provide('everyone_round1_progId', 232);
provide('everyone_round2_progId', 233);

const activeChallenge = computed(() => {
  return everyoneChallenges?.find(challenge => {
    const now = new Date();
    return now >= challenge.collectionFrom && now <= challenge.collectionTo;
  });
});

// Computed property to determine which component to show based on current section
const currentPage = computed(() => {
  return currentSection.value;
});

// Watch for currentPage changes and scroll to the respective section
watch(
  () => currentPage.value,
  () => {
    // Use nextTick to ensure DOM is updated before scrolling
    nextTick(() => {
      const scrollTarget = document.getElementById('scroll-page');

      if (scrollTarget) {
        // Get the element's position and subtract 100px
        const elementTop = scrollTarget.offsetTop;
        const scrollPosition = elementTop - 70;

        // Smooth scroll to the calculated position
        window.scrollTo({
          top: Math.max(0, scrollPosition), // Ensure we don't scroll to negative position
          behavior: 'smooth'
        });
      } else {
        // Fallback: scroll to top of page smoothly
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    });
  },
  { immediate: false } // Don't trigger on initial mount
);

const handleNavigateFromMain = (type: string) => {
  if (type === 'everyone') {
    currentSection.value = 'modu';
    updateUrl('modu');
  } else if (type === 'campus') {
    currentSection.value = 'campus';
    updateUrl('campus');
  } else if (type === 'caution') {
    currentSection.value = 'caution';
    updateUrl('caution');
  }
};

const handleBtnParticipate = (type: string) => {
  if (type === 'everyone') {
    onMenuItemClick(menus.value[1]);
    participate('everyone');
  } else if (type === 'campus') {
    onMenuItemClick(menus.value[2]);
    participate('campus');
  }
  hidePopup();
};


return (_ctx: any,_cache: any) => {
  return (pageInited.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menus).slice(0, 4), (menu, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["mobile-tab-item", { active: _unref(activeMenuIndex) === index }]),
                onClick: ($event: any) => (onMenuItemClick(menu))
              }, _toDisplayString(menu.name), 11, _hoisted_4))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_Transition, { name: "navbar-fade" }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(Navbar, {
                sticky: "",
                "active-menu-index": _unref(activeMenuIndex),
                menus: _unref(menus),
                onMenuClick: onMenuItemClick
              }, null, 8, ["active-menu-index", "menus"]), [
                [_vShow, !navbarIsVisible.value]
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode(HeroSection),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(Navbar, {
            ref_key: "navContainer",
            ref: navContainer,
            sticky: false,
            "active-menu-index": _unref(activeMenuIndex),
            menus: _unref(menus),
            onMenuClick: onMenuItemClick
          }, null, 8, ["active-menu-index", "menus"])
        ]),
        (!isStartParticipate.value && !isStartCollect.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(currentPage) === 'main')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    id: "page-main",
                    ref_key: "pageMainRef",
                    ref: pageMainRef
                  }, [
                    _createVNode(PageMain, { onNavigate: handleNavigateFromMain })
                  ], 512))
                : _createCommentVNode("", true),
              (_unref(currentPage) === 'modu')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    id: "page-everyone-challenge",
                    ref_key: "everyoneChallengeRef",
                    ref: everyoneChallengeRef
                  }, [
                    _createVNode(EveryoneChallenge, {
                      challenges: _unref(everyoneChallenges),
                      onShowError: handleShowError
                    }, null, 8, ["challenges"])
                  ], 512))
                : _createCommentVNode("", true),
              (_unref(currentPage) === 'campus')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    id: "campusChallenge",
                    ref_key: "campusChallengeRef",
                    ref: campusChallengeRef
                  }, [
                    _createVNode(CampusChallenge, {
                      challenges: [campusChallenge],
                      onShowError: handleShowError
                    }, null, 8, ["challenges"])
                  ], 512))
                : _createCommentVNode("", true),
              (_unref(currentPage) === 'caution')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    id: "cautionRef",
                    ref_key: "cautionRef",
                    ref: cautionRef
                  }, [
                    _createVNode(CautionPage)
                  ], 512))
                : _createCommentVNode("", true)
            ], 64))
          : (isStartParticipate.value && !isStartCollect.value)
            ? (_openBlock(), _createBlock(Participate, {
                key: 1,
                "challenge-type": challengeType.value,
                challenges: challengeType.value == 'everyone' ? _unref(everyoneChallenges) : [campusChallenge],
                type: 'participate'
              }, null, 8, ["challenge-type", "challenges"]))
            : (!isStartParticipate.value && isStartCollect.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (challengeType.value=='everyone' && _unref(activeChallenge))
                    ? (_openBlock(), _createBlock(EveryoneCollectPage, {
                        key: 0,
                        challenge: _unref(activeChallenge),
                        type: "collect"
                      }, null, 8, ["challenge"]))
                    : _createCommentVNode("", true),
                  (challengeType.value=='campus')
                    ? (_openBlock(), _createBlock(CampusCollectPage, { key: 1 }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
        _createVNode(CheckPopups, {
          ref_key: "checkPopupsRef",
          ref: checkPopupsRef
        }, null, 512),
        _createVNode(QuizPoupups, {
          ref_key: "quizPopupsRef",
          ref: quizPopupsRef,
          onSuccess: onQuizeDone
        }, null, 512),
        _createVNode(ParticipatePopups, {
          ref_key: "participatePopupsRef",
          ref: participatePopupsRef
        }, null, 512),
        _createVNode(CollectPopups, {
          ref_key: "collectPopupsRef",
          ref: collectPopupsRef
        }, null, 512),
        _createVNode(PopupChooseChallangeType, {
          modelValue: _unref(popupVisible).chooseChallenge,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(popupVisible).chooseChallenge) = $event)),
          class: "chooseChallengeWrapper"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "btn-choose-challenge-type flex-grow-1",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {handleBtnParticipate('everyone');})
                }, " 모두의 챌린지 "),
                _createElementVNode("div", {
                  class: "btn-choose-challenge-type flex-grow-1",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {handleBtnParticipate('campus');})
                }, " 캠퍼스 챌린지 ")
              ]),
              _hoisted_11
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(PopupError, {
          modelValue: _unref(popupVisible).error,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(popupVisible).error) = $event)),
          title: errMsg.value
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "footer-btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (hidePopup()))
              }, " 확인했어요 ")
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "title"]),
        _createVNode(NoticePopup, {
          modelValue: showNoticePopup.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showNoticePopup).value = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(SscolaFooter)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})